import ListingCard from "../Common/ListingCard";
import Modal from "./Modal";

const ExpiredListingCard = ({
  title = "Toyota Fortuner D-D4D 4BY4",
  imageUrls = [],
  description = "Lorem ipsum dolor sit amet consectetur. Habitant magna et volutpat consectetur. Diam vestibulum rutrum odio amet massa nibh eget tellus.",
}) => {
  return (
    <div className="relative">
      <ListingCard className="blur-[2px]" />
      <Modal />
    </div>
  );
};

export default ExpiredListingCard;
